import React from "react";
import SmiWidget15747 from './SmiWidget15747'
import AdFoxTGB4 from './AdFoxTGB4'
import parseTextFromJson from "../utils/parseOldArticle"

function div(arr) {
    const n = arr.length / 2;
    return [arr.slice(0, n), arr.slice(n)];
}


function split(news) {
    let el = document.createElement("div");

    if (news.content[0] === '{') {
        el.innerHTML = parseTextFromJson(news.content)
    } else {
        el.innerHTML = news.content
    }

    const chunks = Array.from(el.children).map(el => el.innerHTML);

    const fourth = Math.ceil(chunks.length / 4);

    return chunks;
}

class NewsText extends React.Component {
    constructor(props) {
        super(props);
        this.contentRef = React.createRef();
        this.state = {
            toggle: true
        }
    }

    toggleNews = () => {
        this.setState({toggle: false})
        console.log(this.state)
    }

    render() {
        const {news, teasers, onClick} = this.props;
        const chunks = split(news);

        return (
            <div className="news-text-900">
                <div ref={this.contentRef}>
                    {chunks.map((chunk, i) => {
                        return (
                            <React.Fragment key={i}>
                                <p dangerouslySetInnerHTML={{__html: chunk}}/>
                            </React.Fragment>
                        );
                    })}
                </div>
            </div>
        );
    }
}

export default NewsText;
